import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  tableHead: { fontWeight: 600 },
  loading: { padding: '25px' },
}))

export { useStyles }
